import { Box, Paper, Skeleton, Stack } from '@mui/material';

const SmtpConfigLoader = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        p: 3,
        mt: 2
      }}
    >
      {/* Title */}
      <Skeleton variant='text' width={100} height={28} />
      <Skeleton variant='text' width='60%' height={20} sx={{ mt: 1, mb: 2 }} />

      {/* Info box */}
      <Box
        sx={{
          border: '1px solid #E0E0E0',
          bgcolor: '#f4f8ff',
          p: 2,
          borderRadius: 1,
          mb: 3
        }}
      >
        <Skeleton variant='text' width='80%' height={18} />
        <Skeleton variant='text' width='60%' height={18} />
      </Box>

      {/* Input fields */}
      <Stack spacing={2}>
        <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 1 }} />
      </Stack>
    </Paper>
  );
};

export default SmtpConfigLoader;
